module.exports = __webpack_public_path__ + "img/logo_white_text.873a6097.svg";